import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    invoiceList: [],
    invoiceListCount: null,
    invoiceFilter: {
        main_filter: null,
        fields: {
            invoiceCompanyId: null,
        },
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
